import { Box, Stack, useTheme } from '@mui/material'
import { Outlet } from 'react-router-dom'

import LoadingWithBackdrop from '~/components/loadingWithBackdrop'
import PageErrorBoundary from '~/components/pageErrorBoundary'
import usePrivateRoutesRedirect from '~/hooks/usePrivateRoutesRedirect'
import useStoreTrackingParams from '~/hooks/useStoreTrackingParams'
import Footer from '~/layouts/app/footer'
import Header from '~/layouts/app/header'
import rem from '~/utils/ui'

function AppLayout() {
  const theme = useTheme()

  const isAuthCheckComplete = usePrivateRoutesRedirect({
    requiredUserGroups: null,
    isMarketingPage: true,
  })

  useStoreTrackingParams()

  if (!isAuthCheckComplete) {
    return <LoadingWithBackdrop show />
  }

  return (
    <Stack spacing={0} sx={{ minHeight: '100vh' }}>
      <Header />
      <Box
        sx={{
          background: theme.palette.tertiary3,
          mt: { xxxs: rem(72), sm: rem(96) },
        }}
      >
        <PageErrorBoundary>
          <Outlet />
        </PageErrorBoundary>
      </Box>
      <Footer isMarketingPage />
    </Stack>
  )
}

export default AppLayout
